/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, ErrorFlow, BrickContext } from 'olympe';

export default class SetInIndexedDB extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} db
     * @param {string} store
     * @param {string} key
     * @param {*} value
     * @param {function(*): void} setDb
     * @param {function(): void} forwardEvent
     * @param {function(*): void} setErrorFlow
     */
    update($, [db, store, key, value], [forwardEvent, setDb, setErrorFlow]) {
        setDb(db);
        if (!db.objectStoreNames.contains(store)) {
            setErrorFlow(ErrorFlow.create("The store doesn't exist", 1));
        } else {
            const objectStore = db.transaction(store, 'readwrite').objectStore(store);
            const updateTitleRequest = objectStore.put({ k: key, v: value });
            updateTitleRequest.onsuccess = () => {
                forwardEvent();
            };
        }
    }
}

registerBrick('018ae05fa62601ba6d3d', SetInIndexedDB);
